(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function getShopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function macinoUpdateCartBubble(cart) {
    var cartBubbles = document.querySelectorAll(
      '.cart-count-bubble, .cart-count, [data-cart-count]'
    );

    cartBubbles.forEach(function (bubble) {
      bubble.textContent = cart.item_count;

      if (cart.item_count > 0) {
        bubble.classList.remove('is-hidden');
        bubble.hidden = false;
      } else {
        bubble.classList.add('is-hidden');
      }
    });
  }

  function macinoShowToast(message, isError) {
    var oldToast = document.querySelector('.macino-cart-toast');

    if (oldToast) {
      oldToast.remove();
    }

    var cartTarget = document.querySelector(
      '.macino-cart-toggle, .cart-icon-link, .cart-header-icon'
    );

    var toast = document.createElement('div');

    toast.className = 'macino-cart-toast';

    if (isError) {
      toast.classList.add('is-error');
    }

    toast.innerHTML =
      '<span>' +
      (isError ? '!' : '🐾') +
      '</span><strong>' +
      message +
      '</strong>';

    document.body.appendChild(toast);

    if (cartTarget) {
      var cartRect = cartTarget.getBoundingClientRect();
      var toastRect = toast.getBoundingClientRect();

      var left =
        cartRect.left +
        cartRect.width / 2 -
        toastRect.width / 2;

      var top = cartRect.bottom + 10;

      left = Math.max(
        12,
        Math.min(
          left,
          window.innerWidth - toastRect.width - 12
        )
      );

      toast.style.left = left + 'px';
      toast.style.top = top + 'px';
      toast.style.right = 'auto';
      toast.style.bottom = 'auto';
    }

    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    setTimeout(function () {
      toast.classList.remove('is-visible');

      setTimeout(function () {
        toast.remove();
      }, 260);
    }, 1900);
  }

  function macinoCartPop() {
    document.body.classList.add('macino-cart-pop');

    setTimeout(function () {
      document.body.classList.remove('macino-cart-pop');
    }, 850);
  }

  function macinoAnimatePawsToCart(button) {
    var cartIcon = document.querySelector(
      '.cart-icon-link, .macino-cart-toggle, .cart-header-icon'
    );

    if (!button || !cartIcon || !window.macinoPawImageUrl) {
      macinoCartPop();
      return;
    }

    var buttonRect = button.getBoundingClientRect();
    var cartRect = cartIcon.getBoundingClientRect();

    var startX = buttonRect.left + buttonRect.width / 2;
    var startY = buttonRect.top + buttonRect.height / 2;
    var endX = cartRect.left + cartRect.width / 2;
    var endY = cartRect.top + cartRect.height / 2;

    var pawCount = window.innerWidth <= 900 ? 5 : 7;

    for (var i = 0; i < pawCount; i++) {
      (function (index) {
        var paw = document.createElement('img');
        var progress = index / Math.max(1, pawCount - 1);
        var curveOffset =
          Math.sin(progress * Math.PI) * -80;

        var currentX =
          startX + (endX - startX) * progress;

        var currentY =
          startY +
          (endY - startY) * progress +
          curveOffset;

        paw.className = 'macino-flying-paw';
        paw.src = window.macinoPawImageUrl;
        paw.alt = '';

        paw.style.left = startX + 'px';
        paw.style.top = startY + 'px';
        paw.style.opacity = '0';

        paw.style.transform =
          'translate(-50%, -50%) scale(0.72) rotate(' +
          (-18 + index * 9) +
          'deg)';

        document.body.appendChild(paw);

        setTimeout(function () {
          paw.classList.add('is-visible');

          paw.style.left = currentX + 'px';
          paw.style.top = currentY + 'px';

          paw.style.opacity = String(
            0.95 - progress * 0.45
          );

          paw.style.transform =
            'translate(-50%, -50%) scale(' +
            (0.75 + progress * 0.18) +
            ') rotate(' +
            (-12 + index * 8) +
            'deg)';
        }, index * 70);

        setTimeout(function () {
          paw.style.left = endX + 'px';
          paw.style.top = endY + 'px';
          paw.style.opacity = '0';

          paw.style.transform =
            'translate(-50%, -50%) scale(0.35) rotate(' +
            (18 + index * 10) +
            'deg)';
        }, 430 + index * 70);

        setTimeout(function () {
          paw.remove();

          if (index === pawCount - 1) {
            macinoCartPop();
          }
        }, 980 + index * 55);
      })(i);
    }
  }

  function showFormMessage(form, message, isError) {
    var messageElement = form.querySelector(
      '.add-to-cart-message'
    );

    if (!messageElement) {
      return;
    }

    messageElement.textContent = message;
    messageElement.hidden = false;

    if (isError) {
      messageElement.classList.add('is-error');
    } else {
      messageElement.classList.remove('is-error');
    }
  }

  function hideFormMessage(form) {
    var messageElement = form.querySelector(
      '.add-to-cart-message'
    );

    if (!messageElement) {
      return;
    }

    messageElement.hidden = true;
    messageElement.classList.remove('is-error');
  }

  function bindAjaxCart() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target.closest(
          'form[action*="/cart/add"]'
        );

        if (!form) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (form.dataset.macinoSubmitting === 'true') {
          return;
        }

        var button =
          event.submitter ||
          form.querySelector(
            'button[type="submit"], .card-cta'
          );

        var isBuyNow = Boolean(
          button &&
            (button.hasAttribute('data-buy-now') ||
              button.name === 'checkout')
        );

        var variantInput = form.querySelector(
          '[name="id"]'
        );

        var quantityInput = form.querySelector(
          '[name="quantity"]'
        );

        if (!variantInput || !variantInput.value) {
          console.error(
            'Macino: ID-ul variantei nu a fost găsit.'
          );

          showFormMessage(
            form,
            'Varianta produsului nu a putut fi identificată.',
            true
          );

          return;
        }

        var variantId = parseInt(
          variantInput.value,
          10
        );

        var quantity = quantityInput
          ? parseInt(quantityInput.value, 10) || 1
          : 1;

        quantity = Math.max(1, quantity);

        if (!variantId) {
          showFormMessage(
            form,
            'Varianta selectată nu este validă.',
            true
          );

          return;
        }

        var originalText = button
          ? button.textContent.trim()
          : isBuyNow
            ? 'Cumpără acum'
            : 'Adaugă în coș';

        form.dataset.macinoSubmitting = 'true';

        hideFormMessage(form);

        if (button) {
          button.disabled = true;
          button.textContent = isBuyNow
            ? 'Se pregătește...'
            : 'Se adaugă...';
        }

        var controller = new AbortController();

        var requestTimeout = setTimeout(function () {
          controller.abort();
        }, 12000);

        fetch(getShopifyRoot() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          }),
          signal: controller.signal
        })
          .then(function (response) {
            return response
              .json()
              .catch(function () {
                return {};
              })
              .then(function (data) {
                if (!response.ok) {
                  throw new Error(
                    data.description ||
                      data.message ||
                      'Nu s-a putut adăuga produsul în coș.'
                  );
                }

                return data;
              });
          })
          .then(function () {
            clearTimeout(requestTimeout);

            if (isBuyNow) {
              window.location.assign('/checkout');
              return null;
            }

            return fetch(
              getShopifyRoot() + 'cart.js',
              {
                method: 'GET',
                headers: {
                  Accept: 'application/json',
                  'X-Requested-With':
                    'XMLHttpRequest'
                },
                cache: 'no-store'
              }
            );
          })
          .then(function (response) {
            if (!response) {
              return null;
            }

            if (!response.ok) {
              throw new Error(
                'Produsul a fost adăugat, dar coșul nu s-a putut actualiza.'
              );
            }

            return response.json();
          })
          .then(function (cart) {
            if (!cart) {
              return;
            }

            macinoUpdateCartBubble(cart);
            macinoAnimatePawsToCart(button);
            macinoShowToast(
              'Produs adăugat în coș',
              false
            );

            showFormMessage(
              form,
              'Produsul a fost adăugat în coș ✓',
              false
            );

            if (button) {
              button.textContent = 'Adăugat ✓';
              button.classList.add('is-added');
            }

            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                bubbles: true,
                detail: {
                  cart: cart
                }
              })
            );

            setTimeout(function () {
              form.dataset.macinoSubmitting =
                'false';

              if (button) {
                button.disabled = false;
                button.textContent =
                  originalText ||
                  'Adaugă în coș';

                button.classList.remove(
                  'is-added'
                );
              }
            }, 1500);
          })
          .catch(function (error) {
            clearTimeout(requestTimeout);

            console.error(
              'Macino add-to-cart:',
              error
            );

            form.dataset.macinoSubmitting = 'false';

            var errorMessage;

            if (error.name === 'AbortError') {
              errorMessage =
                'Cererea a durat prea mult. Încearcă din nou.';
            } else {
              errorMessage =
                error.message ||
                'Produsul nu a putut fi adăugat în coș.';
            }

            showFormMessage(
              form,
              errorMessage,
              true
            );

            macinoShowToast(
              errorMessage,
              true
            );

            if (button) {
              button.disabled = false;
              button.textContent =
                'Încearcă din nou';

              setTimeout(function () {
                button.textContent =
                  originalText ||
                  (isBuyNow
                    ? 'Cumpără acum'
                    : 'Adaugă în coș');
              }, 1800);
            }
          });
      },
      true
    );
  }

  function bindSmallInteractions() {
    document
      .querySelectorAll('[data-scroll-to]')
      .forEach(function (element) {
        element.addEventListener(
          'click',
          function (event) {
            var target = document.querySelector(
              element.dataset.scrollTo
            );

            if (!target) {
              return;
            }

            event.preventDefault();

            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        );
      });
  }

  function bindQuantityControls() {
    document.addEventListener('click', function (event) {
      var changeButton = event.target.closest(
        '[data-quantity-change]'
      );

      if (!changeButton) {
        return;
      }

      var control = changeButton.closest(
        '[data-quantity-control]'
      );

      var input = control
        ? control.querySelector('input[name="quantity"]')
        : null;

      if (!input) {
        return;
      }

      event.preventDefault();

      var minimum = parseInt(input.min, 10) || 1;
      var maximum = parseInt(input.max, 10);
      var currentValue = parseInt(input.value, 10) || minimum;
      var change = parseInt(
        changeButton.getAttribute('data-quantity-change'),
        10
      ) || 0;

      var nextValue = Math.max(
        minimum,
        currentValue + change
      );

      if (!Number.isNaN(maximum)) {
        nextValue = Math.min(maximum, nextValue);
      }

      input.value = nextValue;
      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });
  }

  function bindProductCarousels() {
    document
      .querySelectorAll('[data-product-carousel]')
      .forEach(function (carousel) {
        var section = carousel.closest(
          '.product-all-carousel-section'
        );

        if (!section) {
          return;
        }

        var previousButton = section.querySelector(
          '[data-product-carousel-previous]'
        );

        var nextButton = section.querySelector(
          '[data-product-carousel-next]'
        );

        function updateButtons() {
          var maxScroll = Math.max(
            0,
            carousel.scrollWidth - carousel.clientWidth
          );

          if (previousButton) {
            previousButton.disabled = carousel.scrollLeft <= 4;
          }

          if (nextButton) {
            nextButton.disabled = carousel.scrollLeft >= maxScroll - 4;
          }
        }

        function scrollCarousel(direction) {
          carousel.scrollBy({
            left: direction * Math.max(220, carousel.clientWidth * 0.82),
            behavior: 'smooth'
          });
        }

        if (previousButton) {
          previousButton.addEventListener('click', function () {
            scrollCarousel(-1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', function () {
            scrollCarousel(1);
          });
        }

        carousel.addEventListener('scroll', function () {
          window.requestAnimationFrame(updateButtons);
        }, { passive: true });

        window.addEventListener('resize', updateButtons, {
          passive: true
        });

        updateButtons();
      });
  }

  function bindStickyHeaderScrollState() {
    var frameId = null;
    var lastScrollY = Math.max(0, window.scrollY);
    var accumulatedScroll = 0;
    var scrollDirection = 0;
    var wasMobile = null;

    function updateHeaderState() {
      var isMobile = window.innerWidth <= 900;
      var currentScrollY = Math.max(0, window.scrollY);

      if (!isMobile) {
        document.body.classList.remove(
          'macino-scrolled'
        );

        lastScrollY = currentScrollY;
        accumulatedScroll = 0;
        scrollDirection = 0;
        wasMobile = false;
        frameId = null;
        return;
      }

      if (wasMobile !== true) {
        document.body.classList.toggle(
          'macino-scrolled',
          currentScrollY > 72
        );

        lastScrollY = currentScrollY;
        accumulatedScroll = 0;
        scrollDirection = 0;
        wasMobile = true;
        frameId = null;
        return;
      }

      var scrollDelta = currentScrollY - lastScrollY;

      if (currentScrollY <= 12) {
        document.body.classList.remove(
          'macino-scrolled'
        );

        accumulatedScroll = 0;
        scrollDirection = 0;
      } else if (Math.abs(scrollDelta) >= 1) {
        var nextDirection = scrollDelta > 0 ? 1 : -1;

        if (nextDirection !== scrollDirection) {
          scrollDirection = nextDirection;
          accumulatedScroll = 0;
        }

        accumulatedScroll += Math.abs(scrollDelta);

        if (accumulatedScroll >= 10) {
          if (scrollDirection > 0 && currentScrollY > 72) {
            document.body.classList.add(
              'macino-scrolled'
            );
          } else if (scrollDirection < 0) {
            document.body.classList.remove(
              'macino-scrolled'
            );
          }

          accumulatedScroll = 0;
        }
      }

      lastScrollY = currentScrollY;
      frameId = null;
    }

    function requestHeaderUpdate() {
      if (frameId !== null) {
        return;
      }

      frameId = window.requestAnimationFrame(
        updateHeaderState
      );
    }

    requestHeaderUpdate();

    window.addEventListener(
      'scroll',
      requestHeaderUpdate,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      requestHeaderUpdate,
      {
        passive: true
      }
    );
  }

  onReady(function () {
    bindStickyHeaderScrollState();
    bindAjaxCart();
    bindSmallInteractions();
    bindQuantityControls();
    bindProductCarousels();
  });
})();
